import { reindexFavourite } from "./toggle_favourite";

(function() {
    reindexFavourite()
}());
